// Based on
// https://reacttricks.com/sharing-global-data-in-next-with-custom-app-and-usecontext-hook/
// https://stackoverflow.com/a/60701229/1017520
import { createContext } from 'react';

import { AuthAdministrator, AuthMember } from 'api';

export interface UserContextObj {
	isUserAuthenticated: boolean;
	organization?: string;
	uid?: string;
	jwt: string;
	user?: AuthAdministrator | AuthMember;

	setDisplayUserLoginOverlay: (state: boolean, callback?: () => void) => void;
	setUserCredentials: (userObj: { access: AuthAdministrator | AuthMember; refresh: string }) => void;
	signIn: (user: AuthAdministrator | AuthMember) => void;
}

export const UserContext = createContext<UserContextObj>({
	isUserAuthenticated: false,
	jwt: '',
	user: undefined,

	setDisplayUserLoginOverlay: () => {},
	setUserCredentials: () => {},
	signIn: () => {},
});

export default UserContext;
